/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "不允许售卖或分享我的个人信息",
      "Bumble Date",
      "我们的应用程序",
      "关于",
      "工作机会",
      "联系我们",
      "投资人",
      "商店",
      "公司",
      "下载应用",
      "Bumble的无障碍服务",
      "指导原则",
      "管理Cookies",
      "现代奴役法案",
      "数据采集说明",
      "隐私政策",
      "条款与条件",
      "法律",
      "华盛顿​消费​者​健康​数据​隐私​政策",
      "扫描二维码​获取Bumble​应用程序",
      "立即终止合同",
      "关闭菜单",
      "打开菜单",
      "语言选项",
      "Footer",
      "Bumble的无障碍可访问性",
      "Apple与Apple商标是Apple Inc.的注册商标",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "工作机会",
      "Google Play是Google LLC的商标。",
      "指导原则",
      "投资人",
      "管理Cookies",
      "现代奴役法案声明",
      "数据采集说明",
      "隐私声明",
      "季节约会指南",
      "条款",
      "应用",
      "华盛顿​消费​者​健康​数据​隐私​政策",
      "关于",
      "大使",
      "结识​新朋友，​寻找​好友圈",
      "以专业的姿态拓展商务人际网，发展职业",
      "遇见爱情，或建立自由无束缚的关系，或建立两者之间的关系",
      "The Buzz",
      "了解更多",
      "使用旅行模式，走向全球",
      "约会",
      "特色功能",
      "Compliments",
      "给对方送上Compliments，从人群中脱颖而出。",
      "发现",
      "个性化​推荐​机制，​为您​推荐​匹配​度​最高​的​人选，​每日​更新。",
      "隐身模式",
      "使用隐身模式隐藏个人档案，不让上司、亲戚或前任看到你的档案。",
      "立即配对",
      "在Bumble线下​活动​中​遇见​了​聊得来​的人？​在​应用​程序​上​继续​聊天。",
      "Opening Moves",
      "预设Opening Moves，卸掉压力，让对方开启聊天。",
      "瞌睡模式",
      "使用瞌睡模式，按下约会暂停键。我们会在这里一直等着你再次出发。",
      "SuperSwipe",
      "有人让你怦然心动？使用SuperSwipe，让对方知道你的心意。",
      "旅行模式",
      "使用旅行模式，品味免税美食，在全球随心配对。",
      "视频聊天",
      "通过视频聊天和语音通话确认你是否想与对方线下见面。",
      "网页版",
      "在浏览器中直接登入Bumble。",
      "下载Bumble​应用程序",
      "BFF",
      "安全",
      "故事",
      "客服",
      "商店",
      "主页",
      "给对方​发​一个​Compliment，​从​人群​中​脱颖​而出。",
      "Compliments",
      "特色功能旨在建立真实、互相尊重和有意义的关系。",
      "隐藏个人档案，​不让​上司、​亲戚​或​前任​看到​您的​档案。",
      "隐身模式",
      "使用​瞌睡​模式，​按下​约会​暂停​键。",
      "瞌睡模式",
      "很喜欢​某人？​表达​您的​心意。",
      "SuperSwipe",
      "探索约会模式",
      "使用​旅行​模式，​选择​任一​城市​随心​配对。",
      "旅行模式",
      "足不出户​收获​真实​交友​体验。",
      "视频聊天",
      "我们的领导团队​将​Bumble​的​价值​感​带入​全国​各地​的​社区。",
      "社区领导者",
      "特色​功能​帮助​您​认识​同频​的​人，​在​您​的​喜好​之上​建立​联系。",
      "组织团体线下活动，或发现附近的活动。",
      "Plans",
      "探索BFF",
      "寻爱指南和灵感，助您找到属于您的爱和友谊。",
      "建议​和​故事，​助您​建立​您​想要​的​友谊。",
      "友情社区",
      "从东京到多伦多，使用Bumble在全球范围内探索发现爱。",
      "爱情故事",
      "计划完美约会，​无论​何时​何地，​或​与谁​约会。",
      "季节约会指南",
      "探索故事",
      "阅读更多",
      "Bumble {{social_network}}账号",
      "联系我们",
      "登录",
      "(opens in new window)",
      "常见问答",
      "Cookie Policy",
      "Bumble—— The Blog",
      "工作机会",
      "聊天",
      "城市",
      "管理Cookies",
      "版权所有© 2006至今。Bumble。保留所有权力。",
      "交友信赖度报告",
      "Apple与Apple商标为Apple Inc.商标。{{__EOL__}}Google Play为Google LLC.商标。",
      "立即下载",
      "Facebook",
      "关注我们",
      "帮助中心",
      "Instagram",
      "语言",
      "LinkedIn",
      "Bumble属于Bumble Inc.",
      "隐私政策",
      "Safety Centre",
      "网站导览",
      "现代奴役法案声明",
      "条件与条款",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小时"
            ],
            "singular": [
                  "小时"
            ]
      },
      "minute": {
            "plural": [
                  "分钟"
            ],
            "singular": [
                  "分钟"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
